import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { EffectsModule } from "@ngrx/effects";
import { StoreModule } from "@ngrx/store";
import { UiConfirmModule } from "@youm-front/ui";
import { DestinationsEffects } from "./+state/effects";
import { DestinationsService } from "./+state/service";
import {
  RTMP_DESTINATIONS_FEATURE_KEY,
  rtmpDestinationsReducer
} from "./+state/reducer";

@NgModule({
  imports: [
    CommonModule,
    UiConfirmModule,
    EffectsModule.forRoot([]),
    EffectsModule.forFeature([DestinationsEffects]),
    StoreModule.forFeature(
      RTMP_DESTINATIONS_FEATURE_KEY,
      rtmpDestinationsReducer
    )
  ],
  providers: [DestinationsService]
})
export class DestinationsDataAccessModule {}
